import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {FormsModule, NgForm} from "@angular/forms";
import {NzSwitchModule} from "ng-zorro-antd/switch";
import {lastValueFrom} from "rxjs";
import {DXSettingsDto, PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-dx-settings",
    imports: [FormsModule, NzSwitchModule],
    templateUrl: "./dx-settings.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./dx-settings.component.scss"
})
export class DXSettingsComponent implements OnInit {
    constructor(private readonly api: PerFormaAPIService) {}

    loading = true;
    settings: DXSettingsDto;
    successMsg = "";
    errorMsg = "";

    async ngOnInit() {
        this.settings = await lastValueFrom(this.api.postApiTenantDxSettings());
        this.loading = false;
    }

    update = async (frm: NgForm) => {
        frm.form.markAllAsTouched();
        this.errorMsg = "";
        this.successMsg = "";
        if (!frm.valid) return;
        try {
            this.loading = true;
            await lastValueFrom(this.api.putApiTenantDxSettings(this.settings));
            this.successMsg = "Settings saved.";
        } finally {
            this.loading = false;
        }
    };
}
